import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import Body from './Body';

interface Props {
  children?: React.ReactNode;
  heading?: React.ReactNode;
  borderColor?: string;
  backgroundColor?: string;
  gridArea?: string;
  className?: string;
  // We export the Header & Body components for neatness
  Header?: React.ComponentType;
  Body?: React.ComponentType;
  display?: string;
}

const Container = styled.div<Props>`
  display: ${({ display }) => display};
  background-color: ${(props) => props.backgroundColor || props.theme.colors.white};
  grid-areas: ${({ gridArea }) => gridArea};
  position: relative;
`;

const Card = ({
  children,
  borderColor,
  backgroundColor,
  gridArea,
  ...rest
}: Props): JSX.Element => (
  <Container
    gridArea={gridArea}
    borderColor={borderColor}
    backgroundColor={backgroundColor}
    {...rest}
  >
    {children}
  </Container>
);

Card.Header = Header;
Card.Body = Body;

export default Card;
